// export default {
//     enterprise_name:''
// }
import Vue from "vue";
import Vuex from "vuex";
import UserOptions from "./user";
import ComOptions from "./com";
import SignalrOpitons from './signalr';
// 应用vuex插件
Vue.use(Vuex);
//引入数据持久化插件vuex-persistedstate
import createPersistedState from "vuex-persistedstate";

// 创建并暴露store
export default new Vuex.Store({
  // 数据,相当于data
  state: {},
  //准备getters——用于将state中的数据进行加工
  getters: {},
  //准备mutations——用于操作数据（state）
  mutations: {},
  //准备actions——用于响应组件中的动作
  actions: {},
  modules: {
    userAbout: UserOptions,
    comAbout: ComOptions,
    signalrAbout: SignalrOpitons,
  },
  //按需配置数据持久化 指定vuex里（home模块）数据持久化
  plugins: [
    createPersistedState({
      //默认名称vuex
      key: "userVuex",

      //默认localStorage 本地储存 这里建议临时储存 也可写成window.sessionStorage
      storage: sessionStorage,

      //默认vuex全部变量
      // paths:['user']
      reducer(val) {
        return {
          user: val.userAbout.user,
          isAuth: val.userAbout.isAuth,
          sessionKeyName: val.userAbout.sessionKey,
        };
      },
    }),
    createPersistedState({
      //默认名称vuex
      key: "comVuex",

      //默认localStorage 本地储存 这里建议临时储存 也可写成window.sessionStorage
      // storage: sessionStorage,

      //默认vuex全部变量
      // paths:['user']
      reducer(val) {
        return {
          isDark: val.comAbout.isDark,
        };
      },
      // 如果你的数据需要经过处理才能恢复，可以使用 restoreState 函数
      // restoreState: (key, storage) => {
      //   const item = storage.getItem(key);
      //   console.log(item);
      //   if (item.isDark) {
      //     return JSON.parse(item.isDark);
      //   }
      //   return {};
      // }
    }),
  ],
});
